export const formatBoolean = (
  value,
  { yes = "Yes", no = "No", fallback = null } = {},
) => {
  if (value === null || value === undefined) return fallback;
  return value ? yes : no;
};
